import React from 'react';
import { Card, Text } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { CardContent, CardHeader } from 'pages/settings/settings.style';
import { List } from 'styles';
import { StandardRow } from 'components/standard-row';
import { useAccountContext } from 'contexts/account';

const getCopy = copyFor('settings.accountSettings');
const { moving } = routes();

interface Props {
  children?: React.ReactNode;
}

export const AccountSettingsBase = ({ children }: Props) => {
  const { selectedAccount, accounts } = useAccountContext();
  const multiAccount = accounts?.length > 1;

  return (
    <Card mobileVariant="flat" margin={{ bottom: '24px' }}>
      <CardHeader>
        <Text tag="h2" textStyle="heading700" margin={{ bottom: '16px' }}>
          {getCopy('title')}
        </Text>
        {multiAccount && (
          <Text margin={{ bottom: '16px' }}>
            {getCopy('description', { accountName: selectedAccount?.name })}
          </Text>
        )}
      </CardHeader>
      <CardContent>
        <List margin="0">
          {children}
          <StandardRow
            iconLinkProps={{ to: moving }}
            includesBuffer={true}
            heading={getCopy('moving.heading')}
            headingTag="h3"
            text={getCopy('moving.copy')}
            bufferWidth="32px"
            mobileBufferWidth="32px"
          />
        </List>
      </CardContent>
    </Card>
  );
};
